module.exports = __webpack_public_path__ + "media/images/countryrect/ae-d9d31624514b688a3bac214e1c13290e.svg";